import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import './CustomDropdown.scss';

const CustomDropdown = ({ options, selected = null, onSelect, placeholder = 'Select an option' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (option) => {
    onSelect(option);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const selectedOption = options.find(option => option.value === selected);

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div className="dropdown-selected" onClick={() => setIsOpen(!isOpen)}>
        {selectedOption ? (
          <div>
            <div className="option-main">{selectedOption.label}</div>
            <div className="option-sub">{selectedOption.sublabel}</div>
          </div>
        ) : (
          placeholder
        )}
        <span className={`arrow ${isOpen ? 'up' : 'down'}`}></span>
      </div>
      {isOpen && (
        <div className="dropdown-options">
          {options.map((option, index) => (
            <React.Fragment key={option.value}>
              <div className="dropdown-option" onClick={() => handleSelect(option)}>
                <div className="option-main">{option.label}</div>
                <div className="option-sub">{option.sublabel}</div>
              </div>
              {index < options.length - 1 && <div className="divider"></div>}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

CustomDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.string.isRequired,
    sublabel: PropTypes.string,
  })).isRequired,
  selected: PropTypes.any,
  onSelect: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};


export default CustomDropdown;